<template>
  <div class="wrap">
    <div class="operate-box">
      <el-checkbox v-model="override" class="override">覆盖原图</el-checkbox>
      <div class="btn cancel" @click="cancel">取消</div>
      <div class="btn confirm" @click="confirm">裁剪</div>
    </div>
    <vueCropper
      ref="cropper"
      :img="data.url"
      :can-scale="option.canScale"
      :info="option.info"
      :max-img-size="option.maxImgSize"
      :output-size="option.outputSize"
      :center-box="option.centerBox"
      :auto-crop="option.autoCrop"
      :limit-min-size="option.limitMinSize"
    />
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import { cropper } from '@/api/common'

export default {
  name: 'ImageCropper',
  components: {
    VueCropper
  },
  props: {
    id: {
      type: Number,
      default: undefined
    },
    data: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      option: {
        maxImgSize: 'max',
        canScale: true,
        info: true,
        centerBox: true,
        outputSize: 1,
        autoCrop: true,
        limitMinSize: [300, 200]
      },
      override: false
    }
  },
  mounted() {
  },
  methods: {
    cancel() {
      this.$emit('cancle')
    },
    confirm() {
      const imgAxis = this.$refs.cropper.getImgAxis()
      const cropAxis = this.$refs.cropper.getCropAxis()
      const scale = this.$refs.cropper.scale
      const x = parseInt((cropAxis.x1 - imgAxis.x1) / scale)
      const y = parseInt((cropAxis.y1 - imgAxis.y1) / scale)
      const w = parseInt(this.$refs.cropper.cropW / scale)
      const h = parseInt(this.$refs.cropper.cropH / scale)
      console.log(this.$refs.cropper)
      // 原图宽高
      console.log(this.data)
      const data = {
        url: this.data.url,
        id: this.data.id,
        dmsFile: this.data.pdfId,
        contentId: this.id,
        nodeId: 133,
        width: w,
        height: h,
        x: x,
        y: y,
        override: this.override ? 1 : 0
      }
      cropper(data).then(response => {
        console.log(response)
        const { code, data } = response
        if (code === 200) {
          this.$emit('success', data)
          this.$message.success('裁剪成功')
        }
      })
    }
  }
}
</script>

<style scoped>
.param-wrap {
  position: fixed;
  top: 0;
  left: 30%;
  right: 30%;
  height: 50px;
  background: #000;
  z-index: 999;
}

.wrap {
  width: 100%;
  height: 100%;
}

.wrap /deep/ .vue-cropper {
  background: #444;
}

.operate-box {
  position: fixed;
  top: 0;
  left: 30%;
  right: 30%;
  height: 50px;
  background: #000;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.override {
  color: #fff;
  margin-right: 20px;
}

.btn {
  display: inline-block;
  margin: 0 10px;
  padding: 5px 15px;
  border-radius: 4px;
  background: #444;
}

.btn:active, .btn:hover {
  background: #222;
}

.btn.confirm {
  color: #fff;
  background: #12aa9c;
}

.btn.confirm:active, .btn.confirm:hover {
  background: #0a8d83;
}
</style> 